import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    bienDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_DATOS'(state) {
        state.bienDatos = [];
    },
    'SET_DATOS'(state, bienDatos) {
        state.bienDatos = bienDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    getDatos ( { commit }, bienId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (bienId != 0) {
                apiAxios.get(`bienes/${bienId}`) 
                    .then(res => {
                        let datos = [
                            // { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'codigo', 'campo': 'Cod.', 'valor': res.data.codigo, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'descripcion', 'campo': 'Descripcion', 'valor': res.data.descripcion, 'formato': '' },
                            { 'nombre': 'rubro', 'campo': 'Rubro', 'valor': res.data.rubro, 'formato': '' },
                            { 'nombre': 'cotizacion', 'campo': 'Cotizacion', 'valor': res.data.cotizacion, 'formato': 'moneda' },
                            { 'nombre': 'pjeAmortizacion', 'campo': 'Pje.Amortizacion', 'valor': res.data.pjeAmortizacion, 'formato': 'porcentaje' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                        ];

                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}